import script from "./CancellationError.vue?vue&type=script&setup=true&lang=ts"
export * from "./CancellationError.vue?vue&type=script&setup=true&lang=ts"

import "./CancellationError.vue?vue&type=style&index=0&id=e0ebdbe4&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ebdbe4"]])

export default __exports__